import React from 'react';
import PropTypes from 'prop-types';

/**
 * ProgressSteps Component
 *
 * Shows onboarding progress with step indicators
 *
 * Props:
 * - steps: Array of {label, status} where status is 'complete', 'current', or 'pending'
 */
function ProgressSteps({ steps }) {
  return (
    <div className="bg-white rounded-2xl p-6 mb-6 shadow">
      <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
        Your Progress
      </h3>

      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            {/* Step Circle */}
            <div className="flex flex-col items-center flex-1">
              <div
                className={`
                  w-12 h-12 rounded-full flex items-center justify-center
                  font-bold text-lg border-2 mb-2
                  ${
                    step.status === 'complete'
                      ? 'bg-green-500 border-green-500 text-white'
                      : step.status === 'current'
                      ? 'bg-[#E65100] border-[#E65100] text-white animate-pulse'
                      : 'bg-gray-100 border-gray-300 text-gray-400'
                  }
                `}
              >
                {step.status === 'complete' ? '✓' : index + 1}
              </div>
              <span
                className={`
                  text-sm font-semibold text-center
                  ${step.status === 'current' ? 'text-[#E65100]' : 'text-gray-600'}
                `}
              >
                {step.label}
              </span>
            </div>

            {/* Connecting Line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-1 mb-8 mx-2">
                <div
                  className={`
                    h-full rounded
                    ${steps[index].status === 'complete' ? 'bg-green-500' : 'bg-gray-300'}
                  `}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

ProgressSteps.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      status: PropTypes.oneOf(['complete', 'current', 'pending']).isRequired
    })
  ).isRequired
};

export default ProgressSteps;
